import { observable } from 'mobx'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { PortalsClient } from '../../../../../api/clients/identity/PortalsClient'
import { FullscreenSpinner } from '../../../../../components/feedback/circular'
import {
	PortalPageContext,
	PortalPageContextProvider,
} from './PortalPageContext'
import { PortalSettingsPage } from './PortalSettingsPage'
import { PortalVersionsPage } from './PortalVersionsPage'

export const PortalAdminPage = () => {
	const params = useParams<{ portalId: string }>()

	const portalId = parseInt(params.portalId)
	if (isNaN(portalId)) throw new Error('invalid portal id')

	const [portalData, setPortalData] = useState<PortalPageContext>()
	const [upperPortalNames, setUpperPortalNames] = useState<string[]>([])
	const [selectedTab, setSelectedTab] = useState(0)

	useEffect(() => {
		async function SetPortalContext() {
			const api = new PortalsClient()

			try {
				const { data: portal } = await api.GetPortal(portalId)
				const { data: version } = await api.GetLatestPortalVersion(portalId)

				// get all the latest versions of all the portals so we make sure not
				// to duplicate their names
				const { data: allVersions } = await api.GetLatestPortalVersions()

				if (version === undefined)
					throw new Error(
						`Cannot find a version for portal with id ${portal.id}`,
					)
				const contextInternal: PortalPageContext = {
					version: observable(version),
					portal: portal,
					tabLabels: ['Settings', 'Versions'],
					onTabChanged: (evt, value) => setSelectedTab(value),
				}

				setPortalData(contextInternal)
				setUpperPortalNames(allVersions.map((d) => d.name.toUpperCase()))
			} catch (err) {
				console.error(err)
			}
		}

		SetPortalContext()
	}, [portalId])

	const tabSelector = (tabIndex: number) => {
		if (tabIndex === 0)
			return <PortalSettingsPage portalNames={upperPortalNames} />

		if (tabIndex === 1) return <PortalVersionsPage />
	}

	if (portalData === undefined) return <FullscreenSpinner />
	return (
		<PortalPageContextProvider data={portalData}>
			{tabSelector(selectedTab)}
		</PortalPageContextProvider>
	)
}
